import { CompetitionForm } from '../create/components/competition-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useCompetitionAdminListQuery } from '../admin/queries';
import { useUpdateCompetitionMutation } from '../mutations';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useCompetitionQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { idParamSchema } from '~/schemas';
import { Schema } from '../create/schema';
import { Fragment } from 'react';

export const Page = withPrivateRoute(() => {
  const { id } = useParams(idParamSchema.parse);

  const { data: competition } = useCompetitionQuery(id);
  const { data: admins } = useCompetitionAdminListQuery(id);

  const mutation = useUpdateCompetitionMutation();

  async function handleSubmit(data: Schema) {
    // is_team_comp can only be set during creation, so it's excluded from updates
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { is_team_comp, ...payload } = data;
    return await mutation.mutateAsync({ id, payload });
  }

  if (!competition || !admins) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera tävling" />

      <PageLayout.Section>
        <CompetitionForm
          isPending={mutation.isPending}
          onSubmit={handleSubmit}
          defaultValues={{
            ...competition,
            districts: competition.districts.map(d => d.id),
            admins: admins,
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
